import React, { } from "react";
import "./Service_pages.scss";
import img from "./services/reroot_canal.png"; // Replace with actual path
import img2 from "./services/dental.png";
import imgClinic from "./services/1.JPG";
import { FaCheckCircle, FaMicroscope, FaThumbsUp, FaUserMd, FaHeart, FaClinicMedical, FaSearchPlus } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety, MdOutlineVisibility, MdReplay } from "react-icons/md";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const ReRootCanal = () => {

    const types = [
        {
            title: "Removal of Previous Fillings",
            icon: <MdReplay />,
            desc: "Carefully reopening the treated tooth and removing the old gutta-percha or filling material to gain access to the root canal system once again.",
        },
        {
            title: "Micro-Endodontics",
            icon: <FaSearchPlus />,
            desc: "Using high-powered magnification tools to identify complex or curved canal structures and hidden canals that may have been missed during the initial treatment.",
        },
        {
            title: "Advanced Disinfection",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Thoroughly cleaning and disinfecting the canals using modern endodontic instruments to eliminate persistent bacteria and new-onset infections.",
        },
        {
            title: "Biocompatible Resealing",
            icon: <MdOutlineStarPurple500 />,
            desc: "Reshaping and filling the canals with premium biocompatible materials to hermetically seal the space and prevent any future bacterial leakage.",
        },
    ];

    // const disadvantages = [
    //     {
    //         title: "Structural Complexity",
    //         description: "Retreating a tooth is more complex than the initial root canal, requiring specialized skills and high-powered magnification.",
    //     },
    //     {
    //         title: "Success Rate Variables",
    //         description: "While highly effective, the success of retreatment depends on the extent of the reinfection and the structural integrity of the tooth.",
    //     },
    //     {
    //         title: "Previous Restoration Removal",
    //         description: "Existing crowns or large fillings must be removed to access the canals, which may require replacement after the retreatment is complete.",
    //     },
    //     {
    //         title: "Time Requirement",
    //         description: "Retreatment often requires one or two detailed appointments depending on the complexity of the canal anatomy and infection.",
    //     },
    //     {
    //         title: "Potential for Fractures",
    //         description: "If the tooth has hidden cracks or fractures that led to the initial failure, the tooth may have a guarded long-term prognosis.",
    //     },
    // ];

    const benefits = [
        {
            category: "Tooth Preservation",
            benefit: "Saves Natural Teeth",
            description: "Retreatment allows the dentist to save your original tooth instead of resorting to extraction and replacement.",
        },
        {
            category: "Infection Control",
            benefit: "Eliminates Persistent Bacteria",
            description: "Effectively removes bacteria that remained in the canal system or developed due to leakage or new decay.",
        },
        {
            category: "Functionality",
            benefit: "Restores Chewing Ability",
            description: "By resolving pain and swelling, retreatment restores your normal biting force and oral function.",
        },
        {
            category: "Oral Health",
            benefit: "Protects Surrounding Tissues",
            description: "Resolving a dental abscess prevents the spread of infection to the jawbone and neighboring teeth.",
        },
        {
            category: "Aesthetics",
            benefit: "Corrects Discoloration",
            description: "Resolving internal infection can help improve the appearance of a tooth that has darkened due to decay or old material.",
        },
        {
            category: "Long-Term Value",
            benefit: "Prevents Future Tooth Loss",
            description: "Treating a failed root canal early avoids the higher costs associated with implants, bridges, or dentures.",
        },
    ];

    const reasons = [
        {
            icon: <FaUserMd />,
            title: 'Experienced Endodontic Specialists',
            description: 'Our team consists of specialists specifically trained in complex root canal retreatment and internal tooth surgery.'
        },
        {
            icon: <FaMicroscope />,
            title: 'Microscope-Assisted Procedures',
            description: 'We use high-powered dental microscopes for precision that is impossible to achieve with the naked eye.'
        },
        {
            icon: <MdOutlineVisibility />,
            title: 'Advanced CBCT Imaging',
            description: 'Digital 3D evaluations allow us to map out the root anatomy perfectly before we even begin the treatment.'
        },
        {
            icon: <FaHeart />,
            title: 'Pain-Free & Comfortable',
            description: 'Performed under modern local anesthesia, our retreatments are designed to be completely comfortable and stress-free.'
        },
        {
            icon: <FaThumbsUp />,
            title: 'High Success Rates',
            description: 'By addressing the specific cause of failure, we help patients keep their natural teeth for many more years.'
        },
        {
            icon: <FaClinicMedical />,
            title: 'Comprehensive Restoration',
            description: 'From endodontic surgery to the final protective crown placement, we handle the entire process under one roof.'
        }
    ];

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Re-Root Canal Treatment in HSR Layout | Failed Root Canal Retreatment</title>
                    <meta
                        name="description"
                        content="Save your tooth with expert Re-Root Canal Treatment in HSR Layout. Kosmix Dental Clinic specializes in treating failed root canals using advanced microscopy and CBCT."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/re-root-canal-treatment-in-hsr-layout"
                    />
                </Helmet>

                {/* HERO SECTION */}
                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
                        Advanced Re-Root Canal Treatment in HSR Layout
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Re-Root Canal Treatment Specialist" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Root canal treatment is highly effective, but occasionally, a tooth may develop infection again months or even years later. At <strong>Kosmix Dental Clinic</strong>, we specialize in Re-Root Canal Treatment (Retreatment) to save your natural tooth and restore your health.
                            </p>
                            <p>
                                Whether the initial failure was due to complex anatomy, delayed crown placement, or new decay, our experienced specialists use <strong>Microscope-assisted technology</strong> and precise diagnostic tools to remove persistent infection safely.
                            </p>
                            <p>
                                Saving your natural tooth helps maintain proper chewing function and prevents the shifting of nearby teeth. Trust our expert endodontic team to provide a safe, comfortable, and highly effective retreatment experience.
                            </p>
                        </div>
                    </div>
                </div>

                {/* DEFINITION SECTION */}
                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="What is Re-Root Canal Treatment?" />
                    <div className="text_first" >
                        <p1>
                            Re-root canal treatment is a specialized procedure performed when a tooth that previously received root canal therapy becomes reinfected. The dentist reopens the tooth, removes the previous filling material, cleans and disinfects the root canals thoroughly, and reseals the tooth to allow it to function normally again.
                        </p1>
                    </div>
                </div>

                {/* COMPARISON/ANALYSIS SECTION */}
                <div className="compare-section">
                    <div className="compare-card crown-card" data-aos="fade-up" data-aos-delay="600">
                        <h3>Why Does a Root Canal Fail?</h3>
                        <h6>
                            Several factors can contribute to the return of infection after an initial treatment:
                        </h6>

                        <ul>
                            <li><strong>Incomplete Cleaning:</strong> Bacteria remaining in narrow or curved canals.</li>
                            <li><strong>Missed Anatomy:</strong> Complex canal structures missed during the first procedure.</li>
                            <li><strong>Delayed Restoration:</strong> Placing a crown too long after the initial treatment.</li>
                            <li><strong>Salivary Leakage:</strong> Bacteria entering the tooth due to a broken filling or crown.</li>
                            <li><strong>Fractures:</strong> New tooth structure damage or cracks over time.</li>
                        </ul>
                    </div>

                    <div className="compare-card bridge-card" data-aos="fade-up" data-aos-delay="600">
                        <h3>Retreatment vs. Extraction</h3>
                        <h6>
                            Patients often wonder which option is better. Here is why we prioritize Retreatment:
                        </h6>

                        <ul>
                            <li><strong>Preservation:</strong> It is always better to keep your natural tooth whenever possible.</li>
                            <li><strong>Complexity:</strong> Extraction leads to missing gaps, requiring implants or bridges.</li>
                            <li><strong>Prevention:</strong> Saving the natural tooth prevents bone loss in the jaw.</li>
                            <li><strong>Comfort:</strong> Your natural tooth provides the most comfortable biting sensation.</li>
                        </ul>
                    </div>
                </div>

                {/* SYMPTOMS SECTION */}
                <section className="importance-section">
                    <div className="content">
                        <h2 className="section-title" data-aos="fade-up">Symptoms That Indicate the Need for Retreatment</h2>
                        <p1 className="text_first" data-aos="fade-up" data-aos-delay="100">
                            Signs of a failed root canal can appear immediately or develop years after the initial procedure:
                        </p1>
                    </div>

                    <div className="importance-cards-container">
                        {[
                            { title: "● Persistent Tooth Pain", desc: "Dull aching or sharp pain that returns to a previously treated tooth." },
                            { title: "● Chewing Sensitivity", desc: "Tenderness or sharp pain when biting down or applying pressure." },
                            { title: "● Gum Swelling", desc: "Inflammation or localized swelling around the gums of the treated tooth." },
                            { title: "● Dental Abscess", desc: "Small, pimple-like bumps on the gums that may discharge fluid." },
                            { title: "● Discoloration", desc: "Darkening or change in color of the tooth structure." },
                        ].map((item, index) => (
                            <div className="importance-card" data-aos="fade-up" data-aos-delay={150 + index * 100} key={index} style={{ borderRadius: '16px' }}>
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* STEP BY STEP PROCEDURE */}
                <section className="timeline-container" style={{ overflowX: 'hidden', padding: '0 1rem' }}>
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="The Re-Root Canal Procedure" />
                        <p className="text_first">
                            Our streamlined clinical process ensures precision and patient comfort at every stage:
                        </p>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">🩺</div>
                        <div className="timeline-content" style={{ borderRadius: '16px' }}>
                            <h3>Diagnosis & CBCT Imaging</h3>
                            <p>We use digital X-rays and 3D CBCT scans to identify the exact source of infection and map out the canal anatomy.</p>
                        </div>
                        <div className="timeline-icon">1</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-left">
                        <div className="timeline-icon">🛠️</div>
                        <div className="timeline-content" style={{ borderRadius: '16px' }}>
                            <h3>Removal of Old Filling</h3>
                            <p>The tooth is reopened under local anesthesia, and previous root canal filling materials are carefully removed.</p>
                        </div>
                        <div className="timeline-icon">2</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">✨</div>
                        <div className="timeline-content" style={{ borderRadius: '16px' }}>
                            <h3>Cleaning & Reshaping</h3>
                            <p>Canals are thoroughly cleaned using modern endodontic instruments and disinfecting solutions to eliminate debris.</p>
                        </div>
                        <div className="timeline-icon">3</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-left">
                        <div className="timeline-icon">🛡️</div>
                        <div className="timeline-content" style={{ borderRadius: '16px' }}>
                            <h3>Filling & Resealing</h3>
                            <p>Once clean, the canals are filled with biocompatible material to seal the space and prevent any further infection.</p>
                        </div>
                        <div className="timeline-icon">4</div>
                    </div>

                    <div className="timeline-step" data-aos="fade-right">
                        <div className="timeline-icon">👑</div>
                        <div className="timeline-content" style={{ borderRadius: '16px' }}>
                            <h3>Restoration with Crown</h3>
                            <p>A new dental crown is placed to strengthen the tooth structure and restore its full functional strength.</p>
                        </div>
                        <div className="timeline-icon">5</div>
                    </div>
                </section>

                {/* TECHNOLOGY HIGHLIGHT */}
                <section className="why-choose-us">
                    <div className="wrapper">
                        <div className="image-side" data-aos="zoom-in" data-aos-delay="100">
                            <img src={img2} alt="Modern Dental Technology" style={{ borderRadius: '16px' }} />
                        </div>

                        <div className="text-side" data-aos="fade-up" data-aos-delay="300">
                            <h2>Advanced Technology for Precision Results</h2>
                            <p style={{ color: 'black' }}>
                                At <strong>Kosmix Dental Clinic</strong>, we utilize state-of-the-art technology to ensure retreated teeth remain healthy for many years.
                            </p>

                            <div className="doctor-info" data-aos="fade-up" data-aos-delay="400" style={{ borderRadius: '16px' }}>
                                <h3>Our Diagnostic Edge</h3>
                                <div className="doctor">
                                    <span className="emoji">🔬</span>
                                    <div>
                                        <h4>Dental Microscopy</h4>
                                        <p>Allows for microscopic precision in cleaning root canal systems.</p>
                                    </div>
                                </div>
                                <div className="doctor">
                                    <span className="emoji">📸</span>
                                    <div>
                                        <h4>3D CBCT Scans</h4>
                                        <p>Detailed evaluation of hidden infections and bone structures.</p>
                                    </div>
                                </div>
                            </div>

                            <p style={{ color: 'black' }}>
                                Treating a failed root canal early prevents the infection from spreading to surrounding tissues, which could eventually lead to tooth loss.
                            </p>
                        </div>
                    </div>
                </section>

                {/* CLINICAL ADVANTAGES GRID -> GUIDANCE LIST */}
                <section className="denture-guidance-hub" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Techniques Used in Retreatment" />
                        <p className="text_first">
                            Our specialists employ various advanced techniques to ensure the highest standard of dental treatment.
                        </p>
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        {types.map((item, idx) => (
                            <div className="guidance-item" key={idx}>
                                <div className="guidance-icon">{item.icon}</div>
                                <span><strong>{item.title}:</strong> {item.desc}</span>
                            </div>
                        ))}
                    </div>
                </section>

                {/* BENEFITS TABLE */}
                <section className="benefits-section" data-aos="fade-up">
                    <div className="benefits-wrapper">
                        <div className="content">
                            <h2 className="section-title">Analysis of Retreatment Benefits</h2>
                        </div>
                        <div className="table-responsive" style={{ borderRadius: '16px' }}>
                            <table className="styled-table">
                                <thead>
                                    <tr>
                                        <th>Advantage Category</th>
                                        <th>Specific Benefit</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {benefits.map((item, index) => (
                                        <tr key={index}>
                                            <td className="category-cell">
                                                {index === 0 || item.category !== benefits[index - 1].category ? item.category : ""}
                                            </td>
                                            <td>{item.benefit}</td>
                                            <td>{item.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                {/* AFTERCARE SECTION -> GUIDANCE LIST */}
                <section className="denture-guidance-hub" data-aos="fade-up">
                    <div className="content">
                        <SectionTitle title="Caring for Your Tooth After Retreatment" />
                        <p className="text_first">
                            With proper maintenance, a retreated tooth can remain healthy and functional for a lifetime:
                        </p>
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        {[
                            { title: "Maintain Oral Hygiene", description: "Consistent brushing twice daily with fluoride toothpaste." },
                            { title: "Daily Flossing", description: "Ensures no bacteria buildup between the retreated tooth and adjacent teeth." },
                            { title: "Avoid Hard Foods", description: "Protect the tooth from excessive pressure immediately after the procedure." },
                            { title: "Regular Checkups", description: "Visit the dentist every 6 months to monitor the bone healing around the roots." },
                            { title: "Follow-up Appointments", description: "Attend scheduled visits to ensure the crown is fitting perfectly over the tooth." },
                        ].map((item, index) => (
                            <div className="guidance-item" key={index}>
                                <FaCheckCircle className="guidance-icon" />
                                <span><strong>{item.title}:</strong> {item.description}</span>
                            </div>
                        ))}
                    </div>
                </section>

                {/* PRICING & FAQ SECTION -> GUIDANCE LIST */}
                <section className="denture-guidance-hub" data-aos="fade-up" style={{ paddingBottom: '0' }}>
                    <div className="content">
                        <SectionTitle title="Re-Root Canal FAQs & Expectations" />
                    </div>

                    <div className="guidance-list" data-aos="fade-up" data-aos-delay="100">
                        <div className="guidance-item">
                            <FaCheckCircle className="guidance-icon" />
                            <span><strong>Is it painful?</strong> No. It is performed under local anesthesia, making it as comfortable as a regular filling.</span>
                        </div>
                        <div className="guidance-item">
                            <FaCheckCircle className="guidance-icon" />
                            <span><strong>How long does it take?</strong> Usually 1–2 appointments depending on the infection's complexity.</span>
                        </div>
                        <div className="guidance-item">
                            <FaCheckCircle className="guidance-icon" />
                            <span><strong>What happens if I ignore it?</strong> Untreated infection spreads, causes bone loss, and eventually leads to total tooth loss.</span>
                        </div>
                        <div className="guidance-item">
                            <FaCheckCircle className="guidance-icon" />
                            <span><strong>Why choose Retreatment over Extraction?</strong> It is the expert choice to save your natural structure and avoid implants or bridges with a highly effective success rate.</span>
                        </div>
                    </div>
                </section>

                {/* WHY CHOOSE US SPLIT LIST */}
                <section className="fmr-why-choose-split">
                    <div className="content" data-aos="fade-up">
                        <SectionTitle title="Why Choose Kosmix for Re-Root Canal Treatment?" />
                        <p className="text_first">
                            Our reputation in Bengaluru is built on professional expertise and total patient comfort:
                        </p>
                    </div>

                    <div className="fmr-split-wrapper">
                        <div className="fmr-split-image" data-aos="fade-right" data-aos-delay="100">
                            <div className="fmr-image-frame" style={{ borderRadius: '16px' }}>
                                <img src={imgClinic} alt="Kosmix Dental Clinic - Advanced Endodontics" style={{ borderRadius: '16px' }} />
                                <div className="fmr-image-overlay" style={{ borderRadius: '16px' }}>
                                    <span className="fmr-badge">HSR Layout, Bengaluru</span>
                                </div>
                            </div>
                            <div className="fmr-image-accent" style={{ borderRadius: '16px' }}></div>
                        </div>

                        <div className="fmr-split-reasons">
                            {reasons.map((reason, index) => (
                                <div
                                    className="fmr-reason-card"
                                    key={index}
                                    data-aos="fade-left"
                                    data-aos-delay={150 + index * 100}
                                    style={{ borderRadius: '16px' }}
                                >
                                    <div className="fmr-reason-icon">{reason.icon}</div>
                                    <div className="fmr-reason-body">
                                        <h3>{reason.title}</h3>
                                        <p>{reason.description}</p>
                                    </div>
                                    <div className="fmr-reason-index">{String(index + 1).padStart(2, '0')}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* FINAL CTA */}
                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>Save Your Tooth <span>Today!</span></h2>
                        <p>A failed root canal doesn't have to mean tooth loss. Experience expert retreatment with advanced technology at Kosmix Dental Clinic.</p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Retreatment Now</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default ReRootCanal;